import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({name: 'newline'})
export class NewlinePipe implements PipeTransform {
  constructor(private sanitized: DomSanitizer) {}

  transform(value: string): SafeHtml {
    // return value
    // if multiple new line in a row, replace with one new line
    let textWithBreaks = value;
    if (textWithBreaks.includes('<br/>')) {
      return this.sanitized.bypassSecurityTrustHtml(textWithBreaks);
    }
    // textWithBreaks = textWithBreaks.replace(/>\n/g, '>');
    // textWithBreaks = textWithBreaks.replace(/\n+/g, '\n');
    // textWithBreaks = textWithBreaks.replace(/\n/g, '<br/>');
    // textWithBreaks = textWithBreaks.replace(/\s+/g, '\s');
    return this.sanitized.bypassSecurityTrustHtml(textWithBreaks);
  }
}
